import { CardContentType, CreateCardResponseType, DeleteCardResponseType, ExportCardsResponseType } from "../types";
import axiosClient from "./axiosClient";

export const cardApi = {
  saveCard: (cardFields: CardContentType, cardTags: number[], userKey: number, token: string, cardKey: number | null, isOwner: boolean, isPublic: boolean): Promise<CreateCardResponseType> => {
    return axiosClient.post(`/saveCard`, {cardFields, cardTags, userKey, token, cardKey, isOwner, isPublic});
  },

  saveImage: (cardKey: number, cardFace: "front" | "back", userKey: number, token: string, imageBase64?:string, imageFile = null) => {
    const formData = new FormData();
    formData.append("cardKey", cardKey.toString());
    formData.append("cardFace", cardFace);
    if (imageFile) {
      formData.append("imageFile", imageFile);
    }
    else if(imageBase64) {
      formData.append("imageBase64", imageBase64);
    }
    else {
      throw new Error("No image provided");
    }
    return axiosClient.post(`/saveImage`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  deleteCard: (cardKey: number, userKey: number, token: string): Promise<DeleteCardResponseType> => {
    return axiosClient.post(`/deleteCard`, {cardKey, userKey, token});
  },

  exportCards: (userKey: number, token: string, exportImages: boolean, encoding: string): Promise<Blob> => {
    return axiosClient.post(`/exportCards`, { userKey, token, exportImages, encoding }, { responseType: "blob" });
  },
  importCards: (userKey: number, token: string, dataMode: string, imageMode: string, csv: string): Promise<ExportCardsResponseType> => {
    return axiosClient.post(`/importCards`, { userKey, token, dataMode, imageMode, csv });
  },
  batchCards: (files: File[]): Promise<any> => {
    const formData = new FormData();
    files.forEach(file => {
      formData.append("files", file);
    });
    return axiosClient.post(`/batchCards`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};